export default __webpack_public_path__ + "static/media/progress_data.90189132.svg";